require('./component/jQueryComponent');
require('./scss/_mobilehead.scss');

let $ = require("jquery");
let jQuery = require("jquery");

require('./scss/bootstrap.css');
require('./scss/style.css');
require('./scss/swiper.css');

//remove sessionStorage
sessionStorage.removeItem('RegistrationInfo');

require('./component/BootstrapComponent');
let regc = require('./component/RegistrationComponent');

jQuery(document).ready(function () {
    require('./component/HomeComponent');
    require('./component/CookieHandlerComponent');
    require('./component/LoginComponent');

    new regc();
    require('./component/KnowladgeBaseComponent');
    let gauth = require('./component/GoogleAuthenticationCompoment');
    (new gauth()).init();

    let facebookReg = require('./component/FacebookAuthComponent');
    (new facebookReg()).init();

    //mobile menu toggle
    $('.mobilehead-menu').on('click', function () {
        $('.mobilhead_menu_rows').slideToggle();
    });

    $('.nav-bubble').on('click',function () {
        window.open(
            'http://www.kulcs-soft.hu/nav',
            '_blank'
        );
    });

    $('.icon-in').on('click', function () {
        window.open('https://www.linkedin.com/company/kulcs-soft-nyrt-', '_black');
    });

    $('.icon-f').on('click', function () {
        window.open('https://www.facebook.com/kulcssoft/', '_black');
    });

    $('.mobile_contact_toggle').on('click', function () {
       $('.mobilehead_contact').slideToggle();
    });

});

module.exports = {
    jquery:  jQuery,
    regcomponent: regc
};


